import React from 'react';
import { View, Text, Image, TouchableOpacity, StyleSheet } from 'react-native';
import { Ionicons } from '@expo/vector-icons';
import { LinearGradient } from 'expo-linear-gradient';
import { getResponsiveValue } from '../styles/breakpoints';
import { colors } from '../styles/theme';

export function VenueCardFile({
  venue,
  isSelected,
  onPress,
  onLongPress,
  onView,
  onAddPhoto,
  onDeletePhoto,
  isDragging = false,
  userData,
}) {
  return (
    <View
      style={[
        styles.container,
      ]}
    >
      <View style={{
        height: '100%',
        position: 'relative',
        borderRadius: 12,
        shadowColor: '#000',
        shadowOffset: { width: 0, height: 2 },
        shadowOpacity: 0.1,
        shadowRadius: 4,
        overflow: 'hidden',
        elevation: 3,

      }}>

        <View style={styles.imageContainer}>
          {userData?.savedVenueImages?.[venue.id] ? (
            <Image
              source={{ uri: userData?.savedVenueImages?.[venue.id] }}
              style={styles.image}
              resizeMode="cover"
            />
          ) : (
            <View style={styles.placeholder} />
          )}

          {/* Photo upload/delete button overlay */}
          <View style={{
            position: 'absolute',
            top: 5,
            right: 5,
          }}>
            <TouchableOpacity
              style={{
                backgroundColor: 'rgba(255,255,255,0.2)',
                borderRadius: 12,
                padding: 5,
                width: 24,
                height: 24,
                alignItems: 'center',
                justifyContent: 'center'
              }}
              onPress={() => {
                if (userData?.savedVenueImages?.[venue.id]) {
                  onDeletePhoto && onDeletePhoto(venue.id);
                } else {
                  onAddPhoto && onAddPhoto(venue.id);
                }
              }}
            >
              {userData?.savedVenueImages?.[venue.id] ? (
                <Ionicons color="#ffffff" size={12} name="trash" />
              ) : (
                <Ionicons color="#ffffff" size={12} name="camera" />
              )}
            </TouchableOpacity>
          </View>

          <LinearGradient
            colors={['rgba(0,0,0,0)', 'rgba(0,0,0,0.5)']}
            onPress={onPress}
            style={styles.gradientOverlay}
          >
            <View style={styles.contentContainer}>
              <View style={styles.textContainer}>
                <Text style={styles.venueName} numberOfLines={1}>
                  {venue.name}
                </Text>
                <Text style={styles.venueLocation} numberOfLines={1}>
                  {venue.city}, {venue.state}
                </Text>
              </View>
              <View>
                <TouchableOpacity
                  style={{
                    backgroundColor: '#666769',
                    padding: getResponsiveValue({
                      mobile: 3,
                      tablet: 3,
                      laptop: 4,
                      desktop: 4,
                    }),
                    borderRadius: 5,
                    alignItems: 'center'
                  }}
                  onPress={() => onView && onView(venue)}
                >
                  <Text style={{
                    color: '#ffffff',
                    fontSize: 10,
                    fontFamily: 'VastagoGrotesk'
                  }}>View</Text>
                </TouchableOpacity>
              </View>
            </View>
          </LinearGradient>
        </View>
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    width: '100%',
    height: '100%',
    marginBottom: 15,
    borderRadius: 12,
    overflow: 'hidden',
  },
  draggingContainer: {
    opacity: 0.5,
    transform: [{ scale: 0.95 }],
  },
  imageContainer: {
    position: 'relative',
    height: '100%',
  },
  image: {
    width: '100%',
    height: '100%',
  },
  placeholder: {
    width: '100%',
    height: '100%',
    backgroundColor: '#34495e',
  },
  gradientOverlay: {
    position: 'absolute',
    bottom: 0,
    left: 0,
    right: 0,
    paddingHorizontal: 10,
    paddingTop: 15,
    paddingBottom: 10,
    flexDirection: 'row',
    gap: 10,
    justifyContent: 'space-between',
  },
  contentContainer: {
    flexDirection: 'row',
    gap: 10,
    justifyContent: 'space-between',
    width: '100%',
  },
  textContainer: {
    flex: 1,
  },
  venueName: {
    color: '#ffffff',
    fontSize: 10,
    fontFamily: 'VastagoGrotesk',
    fontWeight: 'bold',
    marginBottom: 4,
  },
  venueLocation: {
    color: '#ffffff',
    fontSize: 8,
    fontFamily: 'VastagoGrotesk',
    opacity: 0.9,
  },
});